import { usePlanIsNoAddressNeeded as useIsNoAddressNeeded } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-no-address-needed/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanIsNoAddressNeeded = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { isNoAddressNeeded } = viewModel;

	return useIsNoAddressNeeded({
		isNoAddressNeeded,
		onSetViewModel,
	});
};
